module.exports = __webpack_public_path__ + "img/16d001-24.e74866d3.png";